// Guatemala: 22 departamentos (nivel 1) + municipios (nivel 2).
// El nivel 2 incluye cabeceras/ciudades principales como seed;
// el catálogo municipal completo (~340) se carga desde INE Guatemala antes del go-live.
export const geoDataGT = {
    departments: [
        { id: 0, name: "Seleccione Departamento" },
        { id: 1, name: "Alta Verapaz" },
        { id: 2, name: "Baja Verapaz" },
        { id: 3, name: "Chimaltenango" },
        { id: 4, name: "Chiquimula" },
        { id: 5, name: "El Progreso" },
        { id: 6, name: "Escuintla" },
        { id: 7, name: "Guatemala" },
        { id: 8, name: "Huehuetenango" },
        { id: 9, name: "Izabal" },
        { id: 10, name: "Jalapa" },
        { id: 11, name: "Jutiapa" },
        { id: 12, name: "Petén" },
        { id: 13, name: "Quetzaltenango" },
        { id: 14, name: "Quiché" },
        { id: 15, name: "Retalhuleu" },
        { id: 16, name: "Sacatepéquez" },
        { id: 17, name: "San Marcos" },
        { id: 18, name: "Santa Rosa" },
        { id: 19, name: "Sololá" },
        { id: 20, name: "Suchitepéquez" },
        { id: 21, name: "Totonicapán" },
        { id: 22, name: "Zacapa" }
    ],
    municipalities: [
        { provinceId: 0, id: 0, name: "Seleccione Municipio", code: 0 },
        { provinceId: 1, id: 1, name: "Cobán", code: 101 },
        { provinceId: 2, id: 2, name: "Salamá", code: 201 },
        { provinceId: 3, id: 3, name: "Chimaltenango", code: 301 },
        { provinceId: 4, id: 4, name: "Chiquimula", code: 401 },
        { provinceId: 5, id: 5, name: "Guastatoya", code: 501 },
        { provinceId: 6, id: 6, name: "Escuintla", code: 601 },
        { provinceId: 6, id: 7, name: "Puerto San José", code: 602 },
        { provinceId: 7, id: 8, name: "Ciudad de Guatemala", code: 701 },
        { provinceId: 7, id: 9, name: "Mixco", code: 702 },
        { provinceId: 7, id: 10, name: "Villa Nueva", code: 703 },
        { provinceId: 7, id: 11, name: "San Miguel Petapa", code: 704 },
        { provinceId: 7, id: 12, name: "Villa Canales", code: 705 },
        { provinceId: 7, id: 13, name: "Santa Catarina Pinula", code: 706 },
        { provinceId: 8, id: 14, name: "Huehuetenango", code: 801 },
        { provinceId: 9, id: 15, name: "Puerto Barrios", code: 901 },
        { provinceId: 10, id: 16, name: "Jalapa", code: 1001 },
        { provinceId: 11, id: 17, name: "Jutiapa", code: 1101 },
        { provinceId: 12, id: 18, name: "Flores", code: 1201 },
        { provinceId: 13, id: 19, name: "Quetzaltenango", code: 1301 },
        { provinceId: 14, id: 20, name: "Santa Cruz del Quiché", code: 1401 },
        { provinceId: 15, id: 21, name: "Retalhuleu", code: 1501 },
        { provinceId: 16, id: 22, name: "Antigua Guatemala", code: 1601 },
        { provinceId: 17, id: 23, name: "San Marcos", code: 1701 },
        { provinceId: 18, id: 24, name: "Cuilapa", code: 1801 },
        { provinceId: 19, id: 25, name: "Sololá", code: 1901 },
        { provinceId: 19, id: 26, name: "Panajachel", code: 1902 },
        { provinceId: 20, id: 27, name: "Mazatenango", code: 2001 },
        { provinceId: 21, id: 28, name: "Totonicapán", code: 2101 },
        { provinceId: 22, id: 29, name: "Zacapa", code: 2201 }
    ]
};
